
import { Component, Vue, Prop } from 'vue-property-decorator';
import OrderArea from '../order/components/OrderArea.vue';
import OrderDevice from '@/components/DeviceSelectDialog/index.vue';
import DialogSelectEvent from './components/selectEvent.vue';
import { getDepartmentList } from '@/api/company';
import { getEventList, addPollingOnce } from '@/api/orderPolling';
import { UserModule } from '@/store/modules/user';
import CustomerDialog from '@/components/CustomerDialog/levelByLevel.vue';
import SelectDepartment from '../../components/DeptDialog/index.vue';
import OrderAddressCustom from '../order/components/OrderAddressCustom.vue';
import { addOrderServerIsHave, addOrderServerIsMust,checkPermissionUseAndCompany } from '@/utils/permission';
import { OrderType, Type } from '@/types/permissionType';
import DialogLveReportDept from '@/components/DeptLev/index.vue';

@Component({
  name: 'OrderPollingOnce',
  components: {
    OrderArea,
    OrderDevice,
    CustomerDialog,
    SelectDepartment,
    OrderAddressCustom,
    DialogSelectEvent,
    DialogLveReportDept
  }
})
export default class extends Vue {
  private eventname='';
  private customerName='';
  private customerDialogVisible=false;
  private serverCompanyId='';
  private isShowCustomer=false;
  private form:any = {
    event: '',
    servicerDept: {},
    customer: {},
    userDept:{},
    userDeptName:'',
    area: '',
    address: '',
    person: '',
    mobile: '',
    telephone: '',
    device: '',
    number: '1',
    isSelf: '',
    // dept: (UserModule.getUserDeptList && UserModule.getUserDeptList.length === 1) ? UserModule.getUserDeptList[0] : ''
    sendDept:null,
    sendDeptName:'',
  }
  private serDeptOptions=[]
  // 指派部门
  // private deptOptions = UserModule.getUserDeptList
  private serDealDeptment = []
  private dialogEventVisible = false
  private dataEvent = []
  private eventRadio: any = ''

  private isShowSerDept=false;
  private isMustSerDept=false;

  private isShowDevice=false
  private isMustDevice=false

  private isShowCusDept=false;
  private isMustCusDept=false;
  private cusDeptType= 9;//9所有部门
  private cusDeptIsMulti= 1;
  private isHaveUserDept = false;

  private isShowAddressPca=false;
  private isMustAddressPca=false;

  private isShowAddressSelf=false;
  private isMustAddressSelf=false;

  private isShowAddress=false;
  private isMustAddress=false;

  // 默认显示
  private isShowContentUser=true;
  private isShowContentUserMobile=true;
  private isShowContentUserPhone=true;

  private isMustContentUser=false;
  private isMustContentUserMobile=false;
  private isMustContentUserPhone=false;

  private formSearchEvent: any = {
    name: '',
    checkname: ''
  }
  created() {
    this.serverCompanyId = UserModule.getCompanyId;
    let company:any = UserModule.getCompany;
    if (company) {
      this.isShowCustomer = company.vip_level.substr(0, 1) !== '2';
    }
    this.checkServicer();
    this.getEventList();
    this.getDeptList();

    if(this.isShowCusDept){
      if (checkPermissionUseAndCompany(UserModule.getCompanyId, Type.ORDER_REPORT_DEPT)) {
        this.cusDeptType = 9;
        this.cusDeptIsMulti = 1;
        this.getReportDept(9);
      } else if(checkPermissionUseAndCompany(UserModule.getCompanyId, Type.REPORT_DEPT_LOOK_SUB)){
        this.cusDeptType = 6;
        this.cusDeptIsMulti = 1;
        this.getReportDept(6);
      }else{
        // let userDeptList = UserModule.getUserDeptList;
        //   if (!userDeptList || userDeptList.length < 1) {
        //     this.isHaveUserDept = false;
        //   } else if (userDeptList.length === 1) {
        //     this.isHaveUserDept = true;
        //     this.formAdd.userDeptName = userDeptList[0].name;
        //     this.formAdd.userDept = userDeptList[0];
        //   } else {
        //     this.isHaveUserDept = true;
        //   }
        this.cusDeptType = 6;
        this.cusDeptIsMulti = 0;
        this.getReportDept(6);
      }
    }
 
  }
  private checkServicer() {
    this.isShowDevice = addOrderServerIsHave(Type.device, OrderType.CheckModule, '');
    this.isMustDevice = addOrderServerIsMust(Type.device, OrderType.CheckModule, '');
    this.isShowSerDept = addOrderServerIsHave(Type.dept, OrderType.CheckModule, '');
    this.isMustSerDept = addOrderServerIsMust(Type.dept, OrderType.CheckModule, '');
    this.isShowCusDept = addOrderServerIsHave(Type.CUS_DEPT, OrderType.CheckModule, '');
    this.isMustCusDept =  addOrderServerIsMust(Type.CUS_DEPT, OrderType.CheckModule, '');
    this.isShowAddressPca = addOrderServerIsHave(Type.pca, OrderType.CheckModule, '');
    this.isShowAddressSelf = addOrderServerIsHave(Type.myselfPCALs, OrderType.CheckModule, '');
    this.isShowAddress = addOrderServerIsHave(Type.address, OrderType.CheckModule, '');
    this.isShowContentUser = addOrderServerIsHave(Type.contentUser, OrderType.CheckModule, '');
    this.isShowContentUserMobile = addOrderServerIsHave(Type.contentUserMobile, OrderType.CheckModule, '');
    this.isShowContentUserPhone = addOrderServerIsHave(Type.contentUserPhone, OrderType.CheckModule, '');

    this.isMustAddressPca = addOrderServerIsMust(Type.pca, OrderType.CheckModule, '');
    this.isMustAddressSelf = addOrderServerIsMust(Type.myselfPCALs, OrderType.CheckModule, '');
    this.isMustAddress = addOrderServerIsMust(Type.address, OrderType.CheckModule, '');
    this.isMustContentUser = addOrderServerIsMust(Type.contentUser, OrderType.CheckModule, '');
    this.isMustContentUserMobile = addOrderServerIsMust(Type.contentUserMobile, OrderType.CheckModule, '');
    this.isMustContentUserPhone = addOrderServerIsMust(Type.contentUserPhone, OrderType.CheckModule, '');
  }
  private submit() {
    if (!this.form.event || !this.form.event.name) {
      this.showErrorMsg('请选择巡检事件');
      return;
    }
    if (!(this.form.servicerDept && this.form.servicerDept.dept_id) && this.isMustSerDept) {
      this.showErrorMsg('请选择服务部门');
      return;
    }
    if (this.isShowCustomer && (!this.form.customer || !this.form.customer.id)) {
      this.showErrorMsg('请选择客户');
      return;
    }
    if (!this.form.area && this.isMustAddressPca) {
      this.showErrorMsg('请选择省市区');
      return;
    }
    if (!this.form.area && this.isMustAddressSelf) {
      this.showErrorMsg('请选择所在地区');
      return;
    }
    let parameters:any = {};
    parameters.user_id = UserModule.getUserId;
    parameters.user_name = UserModule.getUserName;
    parameters.company_id = UserModule.getCompanyId;
    parameters.servicer_company_id = UserModule.getCompanyId;
    parameters.servicer_company_name = UserModule.getCompanyName;
    if (this.form.servicerDept) {
      if(this.isShowSerDept){
        parameters['servicer_dept_id'] = this.form.servicerDept.dept_id;
        parameters['servicer_dept_name'] = this.form.servicerDept.name;
      }
    }

    if(this.isShowCusDept){
      if ( !this.isHaveUserDept && this.isMustCusDept){
        this.showErrorMsg('请联系管理员加入报修部门');
        return;
      }
      if (this.isHaveUserDept && this.isMustCusDept && !(this.form.userDept && this.form.userDept.dept_id) ) {
        this.showErrorMsg( '请选择报修部门');
        return;
      }
      if (this.form.userDept && this.form.userDept.dept_id) {
        // if(this.isShowCusDept){
          parameters['customer_dept_name'] = this.form.userDept.name;
          parameters['customer_dept_id'] = this.form.userDept.dept_id;
        // }
      }
    }

    parameters.order_create_type = '2';
    parameters.trouble_describle = this.form.event.name;
    let arr:any = [];
    arr.push(this.form.event);
    parameters.event_list = JSON.stringify(arr);
    if (this.isShowCustomer) {
      if (parseInt(this.form.customer.customer_type) === 1) {
        parameters.customer_company_id = this.form.customer.customer_company_id;
        parameters.customer_company_name = this.form.customer.name;
      } else {
        parameters.customer_user_id = this.form.customer.customer_user_id;
        parameters.customer_user_name = this.form.customer.name;
      }
    } else {
      parameters.customer_company_id = UserModule.getCompanyId;
      parameters.customer_company_name = UserModule.getCompanyName;
    }
    if (this.isShowAddressPca) {
      if (this.province) {
        parameters.province = this.province;
        parameters.province_name = this.provinceName;
      }
      if (this.city) {
        parameters.city = this.city;
        parameters.city_name = this.cityName;
      }
      if (this.district) {
        parameters.district = this.district;
        parameters.district_name = this.districtName;
      }
    }
    if (this.isShowAddressSelf) {
      parameters['address_type'] = 3;
      parameters['one_address_id'] = this.oneAddressId;
      parameters['one_address_name'] = this.oneAddress;
      parameters['two_address_id'] = this.twoAddressId;
      parameters['two_address_name'] = this.twoAddress;
      parameters['three_address_id'] = this.threeAddressId;
      parameters['three_address_name'] = this.threeAddress;
    }
    if (!this.form.address && this.isMustAddress) {
      this.showErrorMsg('请输入地址');
      return;
    }
    if (this.isShowAddress) {
      if (this.form.address) {
        parameters.address = this.form.address;
      }
    }

    if (!this.form.person && this.isMustContentUser) {
      this.showErrorMsg('请输入联系人姓名');
      return;
    }
    if (this.form.person) {
      if (this.form.person.length < 2 && this.form.person.length > 10) {
        this.showErrorMsg('请输入2-10位联系人姓名');
        return;
      }
    }
    if (this.isShowContentUser) {
      parameters['name'] = this.form.person;
    }

    if (!(this.form.mobile && this.form.mobile.length > 0) && this.isMustContentUserMobile) {
      this.showErrorMsg('请输入手机号码');
      return;
    }
    if (this.form.mobile && this.form.mobile.length > 0) {
      if (!(this.form.mobile.charAt(0) === '1' && this.form.mobile.length === 11)) {
        this.showErrorMsg('请输入正确的手机号码');
        return;
      }
      if (this.isShowContentUserMobile) {
        parameters['mobile'] = this.form.mobile;
      }
    }
    if (!(this.form.telephone && this.form.telephone.length > 0) && this.isMustContentUserPhone) {
      this.showErrorMsg('请输入联系电话');
      return;
    }
    if (this.form.telephone && this.form.telephone.length > 0) {
      if (!(this.form.telephone.length >= 3 && this.form.telephone.length <= 18)) {
        this.showErrorMsg('请输入3-18位联系电话,支持输入"-"、" _"');
        return;
      }
      if (this.isShowContentUserPhone) {
        parameters['phone_num'] = this.form.telephone;
      }
    }
    if (!this.isMustContentUserPhone && !this.isMustContentUserMobile && this.isShowContentUserMobile && this.isShowContentUserPhone &&
    !(this.form.mobile && this.form.mobile.length > 0) && !(this.form.telephone && this.form.telephone.length > 0)) {
      this.showErrorMsg('请输入手机号码 或 3-18位联系电话,支持输入"-"、" _"');
      return;
    }
    // if (this.form.person) {
    //   parameters.name = this.form.person;
    // }
    // if (this.form.mobile) {
    //   parameters.mobile = this.form.mobile;
    // }
    // if (this.form.telephone) {
    //   parameters.phone_num = this.form.telephone;
    // }
    if (this.form.address) {
      parameters.address = this.form.address;
    }
    if (!this.form.number || parseInt(this.form.number) < 1) {
      this.showErrorMsg('生成单数不正确');
      return;
    }
    parameters.order_amount = this.form.number;
    if (this.isMustDevice && (!this.selectDevice || this.selectDevice.length < 1)) {
      this.showErrorMsg('请选择添加的设备');
      return;
    }
    if (this.selectDevice && this.selectDevice.length > 0) {
      var arrayDevice:any = [];
      this.selectDevice.forEach((device:any) => {
        var dic = {
          'device_id': device.id
        };
        arrayDevice.push(dic);
      });
      var strDevice = JSON.stringify(arrayDevice);
      parameters.device = strDevice;
    }
    if (this.form.isSelf && (this.serDealDeptment && this.serDealDeptment.length > 0) &&
    (!this.form.sendDept || !this.form.sendDept.dept_id)) {
      this.showErrorMsg('请选择自己的部门');
      return;
    }
    parameters.allot_dept_state = this.form.isSelf ? 1 : 0;
    if (this.form.sendDept) {
      parameters.allot_dept_id = this.form.sendDept.dept_id;
      parameters.allot_dept_name = this.form.sendDept.name;
    }
    this.addPollingOnce(parameters);
  }
  // 选择巡检
  private resetSearchEvent() {
    this.page = 1
    this.formSearchEvent.name = ''
    this.formSearchEvent.checkname = ''
    this.getEventList();
  }
  private searchEvent() {
    this.page = 1
    this.getEventList();
  }
  
  //选择巡检事件
  private selectEventFinsh() {
    if (!this.eventRadio) {
      this.showErrorMsg('请选择巡检事件');
      return;
    }
    this.dialogEventVisible = false;
    //将选择的事件 进行倒序
    this.form.event = this.eventRadio;
    if(this.form.event.lower){
      //二级子级倒序
      for (var eidx = 0; eidx < this.form.event.lower.length; eidx++) {
        if(this.form.event.lower[eidx].child){
          this.form.event.lower[eidx].child = this.form.event.lower[eidx].child.reverse();
        }
      }
      this.form.event.lower =  this.form.event.lower.reverse();
    }
    //一级子级倒序
    if(this.form.event.child){
      this.form.event.child =  this.form.event.child.reverse();
    }
    this.eventname = this.form.event.name;
    if (this.form.event && this.form.event.child) {
      for (var i = 0; i < this.form.event.child.length; i++) {
        let even = this.form.event.child[i];
        this.eventname = this.eventname + ' /' + even.name;
        if (i === 2) {
          break;
        }
      }
    }
    if (this.form.event && this.form.event.lower) {
      for (var m = 0; m < this.form.event.lower.length; m++) {
        let lower = this.form.event.lower[m];
        this.eventname = this.eventname + ' /' + lower.name;
        if (m === 2) {
          break;
        }
      }
    }
  }

  // 获取报修部门
  // 报修部门
  private departmentLevVisible=false
  private selectReportDept() {
    this.departmentLevVisible = true;
  }
  private selectDeptLev(value:any) {
    this.form.userDept = value;
  }
  private handleLveReportDeptConfirm() {
    this.departmentLevVisible = false;
    this.form.userDeptName = this.form.userDept.name;
  }
  private closeDialogLveReportDept() {
    this.form.userDept = null;
    this.departmentLevVisible = false;
  }
  private getReportDept(type:any) {
    let params: any = {
      user_id:UserModule.getUserId ? UserModule.getUserId : '0',
      company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
      type: type, // type=9 查所有部门  type=2查服务部门
      size: 1000,
      page: 1,
      source_type: 1
    };
    getDepartmentList(params)
      .then((res) => {
        if (res.data) {
          if (!res.data.list || res.data.list.length < 1) {
            this.isHaveUserDept = false;
          } else if (res.data.list.length === 1) {
            this.isHaveUserDept = true;
            this.form.userDeptName = res.data.list[0].name;
            this.form.userDept = res.data.list[0];
          } else {
            this.isHaveUserDept = true;
          }
        }else{
          this.isHaveUserDept = false;
        }
    
      })
      .catch((err) => {
        let msg = err.msg;
      });
  }
  // 选择部门
  // 选择部门
  getDeptList() {
    const params = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      type: 9,
      dept_type: 2,
      page: 1
    };
    getDepartmentList(params).then(res => {
      if (res.data) {
        this.serDeptOptions = res.data.list;
      } else {
        this.serDeptOptions = [];
      }
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }
  private departmentVisible = false
  private title = '选择部门'

  private selectDeptServicerHandle() {
    this.departmentVisible = true;
  }
  private selectDept(val:any) {
    this.form.servicerDept = val;
  }
  private closeDeptHandle(value: boolean) {
    this.departmentVisible = value;
  }

  // 指派分派部门
  private selfDepartmentLevVisible=false
  private selectSelfDept() {
    this.selfDepartmentLevVisible = true;
  }
  private selectSelfDeptLev(value:any) {
    this.form.sendDept = value;
  }
  private handleLveSelfDeptConfirm() {
    this.selfDepartmentLevVisible = false;
    this.form.sendDeptName = this.form.sendDept.name;
  }
  private closeDialogLveSelfDept() {
    this.form.sendDept = null;
    this.form.sendDeptName = '';
    this.selfDepartmentLevVisible = false;
  }
  private sendSelfTaskHandle(val:any){
    //this.selfDepartmentLevVisible = true;
    //请求部门 
      let params: any = {
        user_id:UserModule.getUserId ? UserModule.getUserId : '0',
        company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
        type: 6, // type=9 查所有部门  type=2查服务部门
        dept_type:2,
        size: 1000,
        page: 1,
        source_type: 1
      };
       getDepartmentList(params)
      .then((res) => {
        if (res.data) {
          this.serDealDeptment = res.data.list ;
          if (!res.data.list || res.data.list.length < 1) {
            console.log()
          } else if (res.data.list.length === 1) {
            this.form.sendDept = res.data.list[0]
            this.form.sendDeptName =  this.form.sendDept.name;
          } else {
            console.log()
          }
        }else{
          console.log()
        }
      })
      .catch((err) => {
        let msg = err.msg;
      });

    // if (val && this.formAdd.isSelf && (this.serDealDeptment && this.serDealDeptment.length == 1) ) {
    //   this.formAdd.sendDept = this.serDealDeptment[0];
    // }
    // else{
    //   this.formAdd.sendDept = '';
    // }
  }

  // 选择客户
  private selectCustomerVisible() {
    this.customerDialogVisible = true;
  }
  private SelectCus(cus:any) {
    this.form.customer = cus;
    this.customerName = cus.name;
    this.provinceName = cus.province_name;
    this.province = cus.province;
    this.cityName = cus.city_name;
    this.city = cus.city;
    this.districtName = cus.district_name;
    this.district = cus.district;
    this.form.area = cus.province_name !== cus.city_name
      ? cus.province_name + '  ' + cus.city_name + '  ' + cus.district_name
      : cus.province_name + '  ' + cus.district_name;
    this.form.address = cus.address;
    this.form.person = cus.manager;
    this.form.mobile = cus.mobile;
    this.form.telephone = cus.phone_num;
  }
  private focusDevice(){
    if(this.isShowCustomer){
      //检查是否选择了客户
      if(!this.form.customer || !this.form.customer.id){
        this.showErrorMsg('请选择客户');
        return;
      }
    }
    this.deviceVisible = true
  }
  private closeCustomerDialog(val:any) {
    this.customerDialogVisible = val;
  }
  private selectAreaHandle() {
    if (this.isShowAddressPca) {
      this.areaVisible = true;
    } else if (this.isShowAddressSelf) {
      this.areaCustomVisible = true;
    }
  }
  // 选择省市区
  private areaVisible = false
  private provinceName=''
  private province=''
  private cityName=''
  private city=''
  private districtName=''
  private district=''
  private closeAreaHandle(value:boolean) {
    this.areaVisible = value;
  }
  private saveAreaHandle(value:any) {
    this.provinceName = value.province_name;
    this.province = value.province;
    this.cityName = value.city_name;
    this.city = value.city;
    this.districtName = value.district_name;
    this.district = value.district;
    this.form.area = value.province_name !== value.city_name
      ? value.province_name + '  ' + value.city_name + '  ' + value.district_name
      : value.province_name + '  ' + value.district_name;
    this.areaVisible = false;
  }
  // 选择自定义
  private areaCustomVisible = false
  private oneAddress=''
  private oneAddressId=''
  private twoAddress=''
  private twoAddressId=''
  private threeAddress=''
  private threeAddressId=''
  private saveAreaCustomHandle(value:any) {
    this.areaCustomVisible = false;
    if (value) {
      if (value.pBean && value.pBean1) {
        this.oneAddress = JSON.parse(value.pBean).address;
        this.oneAddressId = JSON.parse(value.pBean).id;
        this.twoAddress = JSON.parse(value.pBean1).address;
        this.twoAddressId = JSON.parse(value.pBean1).id;
        this.threeAddress = value.address;
        this.threeAddressId = value.id;
      } else if (value.pBean) {
        this.oneAddress = JSON.parse(value.pBean).address;
        this.oneAddressId = JSON.parse(value.pBean).id;
        this.twoAddress = value.address;
        this.twoAddressId = value.id;
        this.threeAddress = '';
        this.threeAddressId = '0';
      } else {
        this.oneAddress = value.address;
        this.oneAddressId = value.id;
        this.twoAddress = '';
        this.twoAddressId = '0';
        this.threeAddress = '';
        this.threeAddressId = '0';
      }
    }
    this.form.area = this.oneAddress + '  ' + this.twoAddress + '  ' + this.threeAddress;
  }
  private closeAreaCustomHandle(value:boolean) {
    this.areaCustomVisible = value;
  }
  // 选择设备
  private deviceName='';
  private deviceVisible = false
  private selectDevice:any = []
  private confirmDeviceHandle(value: any) {
    this.selectDevice = [];
    this.selectDevice.push(value);
    this.deviceName = (value.number ? value.number : '~') + '/' + (value.sn ? value.sn : '~') + '/' + (value.name ? value.name : '~') + '/' +
                (value.brand_name ? value.brand_name : '~') + '/' + (value.product_name ? value.product_name : '~') + '/' + (value.model_name ? value.model_name : '~');
    this.form.device = value;
  }
  private closeDeviceHandle(value: boolean) {
    this.deviceVisible = value;
  }
  // 选择自定义事件
  private page=1;
  private pageCount=0;
  private eventMoreLoad() {
    this.page++;
    this.getEventList();
  }
  private getEventList() {
    let parmars:any = {};
    parmars.user_id = UserModule.getUserId;
    parmars.company_id = UserModule.getCompanyId;
    if (this.formSearchEvent.name) {
      parmars.event_name = this.formSearchEvent.name;
    }
    if (this.formSearchEvent.checkname) {
      parmars.check_name = this.formSearchEvent.checkname;
    }
    parmars.page = this.page;
    getEventList(parmars).then(res => {
      if (res.data) {
        if (this.page === 1) {
          this.dataEvent = res.data.list;
        } else {
          this.dataEvent = this.dataEvent.concat(res.data.list);
        }
        this.pageCount = res.data.page_count;
      } else {
        this.pageCount = 0
        this.dataEvent = [];
      }
    }).catch(err => {
      this.pageCount = 0;
      this.dataEvent = [];
      let msg = err.msg;
    });
  }
  private addPollingOnce(parameters:any) {
    addPollingOnce(parameters).then(res => {
      this.showSecussMsg((res as any).msg);
      this.rest();
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }
  private rest() {
    this.deviceName = '';
    this.deviceVisible = false;
    this.selectDevice = [];
    this.provinceName = '';
    this.province = '';
    this.cityName = '';
    this.city = '';
    this.districtName = '';
    this.district = '';
    this.formSearchEvent = {
      name: '',
      checkname: ''
    };
    this.eventname = '';
    this.customerName = '';
    this.form = {
      event: '',
      customer: {},
      servicerDept: {},
      area: '',
      address: '',
      person: '',
      mobile: '',
      telephone: '',
      device: '',
      number: '1',
      isSelf: '',
      sendDept: null,
    };
  }
  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
  private showSecussMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'success'
    });
  }
}
